import React from 'react';

import { SVGPropsType } from 'src/types';

function Night(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M13.9999 8.53333C13.6666 11.8 10.7999 14.2667 7.46657 13.9333C4.19991 13.6 1.73324 10.7333 2.06657 7.4C2.33324 4.53333 4.59991 2.26667 7.46657 2C5.93324 4.06667 6.39991 7 8.46657 8.53333C10.1332 9.73333 12.3332 9.73333 13.9999 8.53333Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Night;
